const state = {
  notification: {
    variant: undefined,
    message: ''
  }
}
const getters = {
}
const actions = {
}
const mutations = {
  setNotification (state, data) {
    for (let k in data) {
      if (data.hasOwnProperty(k)) {
        Reflect.set(state.notification, k, data[k])
      }
    }
  },
  resetNotification (state) {
    state.notification = {
      variant: undefined,
      message: ''
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
